import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent {
  isDirEndUser: boolean = false;
  isLoggedIn: Boolean = false;
  currentYear = new Date().getFullYear();
  menuVisible: boolean = false;
  subscription: Subscription;

  constructor(private router: Router, private authenticationService: AuthenticationService) {
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // detect browser reload
        this.authenticationService.restorePermissions();
      }
    });
    this.authenticationService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
    });
  }

  sidebarMenuVisible = false;

  toggleNavbarCollapsing() {
    this.sidebarMenuVisible = !this.sidebarMenuVisible;
  }

  menuToggle: any = {
    BC: true,
    Admin: false,
  };

  togleMenuGroup(group: string) {
    this.menuToggle[group] = !this.menuToggle[group];
  }
}
